


export const menu = (lang: string): [string, string][] => lang === 'sk' ? [
	["/ubytovanie/", "Ubytovanie"],
	["/restauracia/", "Reštaurácia"],
	["/okolie/", "Okolie"],
	["/firmy/", "Firmy"],
	["/kontakt/", "Kontakt"],
] : [
	["/en/rooms/", "Rooms"],
	["/en/restaurant/", "Restaurant"],
	["/en/area/", "Area"],
	["/en/companies/", "Companies"],
	["/en/contact-us/", "Contact"],
];
